import { render } from "./page-email-visualisation.vue?vue&type=template&id=07daa2ca"
import script from "./page-email-visualisation.vue?vue&type=script&lang=js"
export * from "./page-email-visualisation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__